<template>
  <el-dialog
    v-if="elderDialogVisible"
    :title="name"
    custom-class="vpop-dialog"
    top="10vh"
    :visible.sync="elderDialogVisible"
    append-to-body
    @close="hidePop"
  >
    <div class="select">
        <span>姓名检索：</span>
        <el-input v-model="keyName" class="w120" placeholder="请输入长者姓名" size="mini" @change="keyNameFunction"></el-input>
            <!-- <span>社区：</span>
            <el-select class="w120" v-model="communityCode" placeholder="请选择" size="mini" @change="communityCodeChange">
                <el-option v-for="item in communityCodeData" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select> -->
            <!-- <span class="ml-20">姓名检索：</span>
            <el-select class="w80" v-model="age" placeholder="请选择" size="mini" @change="selectChange">
                <el-option v-for="item in selectVal" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select> -->
            <!-- <span class="ml-20">体检：</span>
            <el-select class="w80" v-model="TJValue" placeholder="请选择" size="mini" @change="TJselectChange">
                <el-option v-for="item in TJselectVal" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select>
            <span class="ml-20">高血压：</span>
            <el-select class="w80" v-model="XYValue" placeholder="请选择" size="mini" @change="XYselectChange">
                <el-option v-for="item in XYselectVal" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select>
            <span class="ml-20">高血糖：</span>
            <el-select class="w80" v-model="XTValue" placeholder="请选择" size="mini" @change="XTselectChange">
                <el-option v-for="item in XTselectVal" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select>
            <span class="ml-20">是否空巢独居：</span>
            <el-select class="w80" v-model="isKCDJ" placeholder="请选择" size="mini" @change="isKCDJselectChange">
                <el-option v-for="item in isKCDJData" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select>
            <span v-if="subsidyLevelVisible" class="ml-20">空巢独居老人类别：</span>
            <el-select v-if="subsidyLevelVisible" class="w80" v-model="subsidyLevel" placeholder="请选择" size="mini"
                @change="KCDJselectChange">
                <el-option v-for="item in KCDJselectVal" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select>
            <span class="ml-20">设备状态：</span>
            <el-select class="w80" v-model="isDeviceActive" placeholder="请选择" size="mini" @change="isDeviceActiveChange">
                <el-option v-for="item in isDeviceActiveVal" :key="item.Value" :label="item.Name" :value="item.Value">
                </el-option>
            </el-select> -->
        </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        prop="agedLiveTown"
        label="社区"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="agedName" label="姓名" width="100" align="center">
      </el-table-column>
      <el-table-column
        prop="agedIdCard"
        label="身份证号"
        width="150"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="agedBirth"
        label="出生日期"
        width="90"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="age" label="年龄" width="45" align="center">
      </el-table-column>
      <el-table-column prop="agedGender" label="性别" width="45" align="center">
      </el-table-column>
      <el-table-column
        prop="agedPhone"
        label="手机号"
        width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="agedLiveVillage" label="地址" align="center">
      </el-table-column>
      <el-table-column prop="deviceName" label="设备" align="center">
      </el-table-column>
      <el-table-column prop="deviceStatus" label="设备状态" align="center">
      </el-table-column>
      <!-- <el-table-column prop="LSDevice" label="已安装设备" width="100" align="center">
                <template slot-scope="scope">
                    <el-tooltip v-if="scope.row.LSDevice == '摄像头'" class="item" effect="dark" content="摄像头"
                        placement="right">
                        <img @click="toMonier(scope.row.QTCardNum, scope.row.ElderName)" class="pop-equment video"
                            src="../assets/images/equment/sxt.png" alt="">
                    </el-tooltip>
                    <el-tooltip class="item" v-if="scope.row.LSDevice == '红外'" effect="dark" content="红外" placement="right">
                        <img @click="goToEqumentDetail(scope.row)" class="pop-equment" src="../assets/images/equment/hw.png"
                            alt="">
                    </el-tooltip>
                    <el-tooltip v-if="scope.row.LSDevice == '雷达'" class="item" effect="dark" content="雷达" placement="right">
                        <img @click="goToEqumentDetail(scope.row)" class="pop-equment" src="../assets/images/equment/ld.png"
                            alt="">
                    </el-tooltip>
                    <el-tooltip class="item" v-if="scope.row.LSDevice == '手表'" effect="dark" content="手表" placement="right">
                        <img @click="getMapLine(scope.row.CheckDataId, scope.row.ElderName)" class="pop-equment"
                            src="../assets/images/equment/sb.png" alt="">
                    </el-tooltip>
                </template>
            </el-table-column> -->
      <el-table-column prop="LSDevice" v-if="type == 9" label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="toMonier(scope.row.videoPath,scope.row.id)"
            >查看监控</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      :current-page.sync="pageIndex"
      :page-size="10"
      layout="total, prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <JCvideo></JCvideo>
  </el-dialog>
</template>

<script>
import PubSub from "pubsub-js";
import { mapGetters } from "vuex";
import JCvideo from "./JCvideo";
export default {
  name: "JCElderDetail",
  computed: {
    ...mapGetters(["cid"]),
  },
  components:{
    JCvideo
  },
  data() {
    return {
      elderDialogVisible: false,
      pageIndex: 1,
      age: "",
      selectVal: [],
      TJselectVal: [
        {
          Name: "全部",
          Value: "",
        },
        {
          Name: "是",
          Value: "1",
        },
        {
          Name: "否",
          Value: "0",
        },
      ],
      TJValue: "",
      XYselectVal: [
        {
          Name: "全部",
          Value: "",
        },
        {
          Name: "是",
          Value: "1",
        },
        {
          Name: "否",
          Value: "0",
        },
      ],
      XYValue: "",
      XTselectVal: [
        {
          Name: "全部",
          Value: "",
        },
        {
          Name: "是",
          Value: "1",
        },
        {
          Name: "否",
          Value: "0",
        },
      ],
      XTValue: "",
      tableData: [],
      total: 0,
      keyWord: "",
      name: "老人信息",
      isTJ: "",
      isGXY: "",
      isGXT: "",
      KCDJselectVal: [],
      subsidyLevel: "",
      isDeviceActiveVal: [
        {
          Name: "全部",
          Value: "",
        },
        {
          Name: "在线",
          Value: "1",
        },
        {
          Name: "离线",
          Value: "0",
        },
      ],
      isDeviceActive: "",
      communityCode: "",
      communityCodeData: [],
      isKCDJ: "",
      isKCDJData: [
        {
          Name: "全部",
          Value: "",
        },
        {
          Name: "是",
          Value: "1",
        },
        {
          Name: "否",
          Value: "0",
        },
      ],
      subsidyLevelVisible: false,
      type: "6",
      keyName: "",
    };
  },
  watch: {},
  mounted() {
    // this.GetAgedList(this.type, this.pageIndex);
    PubSub.subscribe("JCEqument", (msg, data) => {
      this.elderDialogVisible = data.visible;
      this.name = "老人信息（" + data.name + "）";
      this.type = data.type
      this.GetAgedList(this.type, 1,'');
    });
  },
  methods: {
    keyNameFunction(){
        this.GetAgedList(this.type, this.pageIndex,this.keyName);
    },
    goToEqumentDetail(data) {
      PubSub.publish("EqumentDetail", {
        visible: true,
        data: data,
      });
    },
    getMapLine(id, name) {
      PubSub.publish("mapLine", {
        visible: true,
        id: id,
        name: name,
      });
    },
    toHealthModel(id) {
      let healthurl =
        process.env.VUE_APP_BASE_URL + `/HealthView/?checketId=${id}`;
      window.open(healthurl);
    },
    isKCDJselectChange(data) {
      this.isKCDJ = data;
      this.pageIndex = 1;
      if (data == "1") {
        this.subsidyLevelVisible = true;
      } else {
        this.subsidyLevel = "";
        this.subsidyLevelVisible = false;
      }
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT,
        this.isDeviceActive,
        this.subsidyLevel,
        this.communityCode,
        this.isKCDJ
      );
    },
    communityCodeChange(data) {
      this.communityCode = data;
      this.pageIndex = 1;
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT,
        this.isDeviceActive,
        this.subsidyLevel,
        this.communityCode,
        this.isKCDJ
      );
    },
    TJselectChange(data) {
      console.log(data);
      this.isTJ = data;
      this.pageIndex = 1;
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT
      );
    },
    XYselectChange(data) {
      console.log(data);
      this.isGXY = data;
      this.pageIndex = 1;
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT,
        this.isDeviceActive,
        this.subsidyLevel,
        this.communityCode,
        this.isKCDJ
      );
    },
    XTselectChange(data) {
      console.log(data);
      this.isGXT = data;
      this.pageIndex = 1;
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT,
        this.isDeviceActive,
        this.subsidyLevel,
        this.communityCode,
        this.isKCDJ
      );
    },
    KCDJselectChange(data) {
      console.log(data);
      this.subsidyLevel = data;
      this.pageIndex = 1;
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT,
        this.isDeviceActive,
        this.subsidyLevel,
        this.communityCode,
        this.isKCDJ
      );
    },
    isDeviceActiveChange(data) {
      console.log(data);
      this.isDeviceActive = data;
      this.pageIndex = 1;
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT,
        this.isDeviceActive,
        this.subsidyLevel,
        this.communityCode,
        this.isKCDJ
      );
    },
    toMonier(link,id) {
      let list = [
        {
          Name: "d96b860a-ff98-42a0-b16c-88f661a5722b",
          Value: "1",
          Data: link,
        },
      ];
      PubSub.publish("JCvideo", {
        visible: true,
        list: link,
        id:id
      });
    },
    hidePop() {
      this.keyWord = "";
      this.isTJ = "";
      this.isGXY = "";
      this.isGXT = "";
      this.age = "";
      this.TJValue = "";
      this.XYValue = "";
      this.XTValue = "";
      this.pageIndex = 1;
      this.total = 0;
      this.tableData = [];
      this.isDeviceActive = "";
      this.subsidyLevel = "";
      this.communityCode = "";
      this.isKCDJ = "";
      this.subsidyLevelVisible = false;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetAgedList(this.type, val,this.keyName);
    },
    selectChange(data) {
      console.log(data);
      this.age = data;
      this.pageIndex = 1;
      this.getYNCheckElderInfoList(
        this.cid,
        this.keyWord,
        this.age,
        this.pageIndex,
        this.isTJ,
        this.isGXY,
        this.isGXT,
        this.isDeviceActive,
        this.subsidyLevel,
        this.communityCode,
        this.isKCDJ
      );
    },
    GetAgedList(type, page,name) {
        page = page - 1
      this.$api
        .GetAgedList(type, page,name)
        .then((data) => {
          console.log("-------------------------->ElderDetail");
          console.log(data);
          this.tableData = data.agedList;
          this.total = data.countAge;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}

.select {
  margin-bottom: 10px;
}

.pop-equment {
  width: 30px;
  height: 30px;
}

.video {
  cursor: pointer;
}
</style>